import { BoardType } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useBoardTypeFirestorePersistence(): useBoardTypeFirestorePersistenceReturn {
  return useLazyContext(BoardTypeFirestorePersistenceContext);
}

export type useBoardTypeFirestorePersistenceReturn = {
  getBoardType: (userId: string) => Promise<BoardType | undefined>;
  setBoardType: (userId: string, boardType: BoardType) => Promise<void>;
};

export const BoardTypeFirestorePersistenceContext =
  createContext<LazyValue<useBoardTypeFirestorePersistenceReturn>>(undefined);
